import TextField from '@mui/material/TextField';
import type { ChangeEvent, FocusEvent } from 'react';

type SignupFormFieldProps = {
  id: string;
  label: string;
  value: string;
  placeholder?: string;
  type?: 'text' | 'email' | 'date';
  error?: string;
  showError: boolean;
  onChange: (value: string) => void;
  onBlur: () => void;
  inputMode?: 'text' | 'email' | 'numeric';
  autoComplete?: string;
};

export function SignupFormField({
  id,
  label,
  value,
  placeholder,
  type = 'text',
  error,
  showError,
  onChange,
  onBlur,
  inputMode,
  autoComplete,
}: SignupFormFieldProps): JSX.Element {
  const hasError = showError && Boolean(error);
  const errorId = `${id}-error`;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const handleBlur = (_event: FocusEvent<HTMLInputElement>) => {
    onBlur();
  };

  return (
    <TextField
      id={id}
      name={id}
      label={label}
      value={value}
      placeholder={placeholder}
      type={type}
      fullWidth
      margin="normal"
      variant="outlined"
      error={hasError}
      onChange={handleChange}
      onBlur={handleBlur}
      inputProps={{
        inputMode,
        autoComplete,
        'aria-invalid': hasError,
        'aria-describedby': hasError ? errorId : undefined,
      }}
      InputLabelProps={type === 'date' ? { shrink: true } : undefined}
      helperText={hasError ? error : undefined}
      FormHelperTextProps={
        hasError ? { id: errorId, role: 'alert' } : undefined
      }
      data-testid={`signup-field-${id}`}
    />
  );
}
